import React , {useState } from 'react'
import { useNavigate  , Link  , useParams} from 'react-router-dom'

//URL
import {URL} from '../../../context/URL'

//sweet Alrt 
import {SweetAlrt} from '../../../context/SweetAlrt'

//Incript_password
import {Incript_password} from '../../../context/Incript_password'

//mui
import { Typography , Alert , styled  , TextField} from '@mui/material'


//css
const AlrtBox = styled(Typography)(({theme})=>({
    color:'red',
    marginTop:'-18px',
    marginBottom:'5px',
    paddingLeft:'40px',
    fontSize:'15px',
    "@media (max-width:390px) ":{
        fontSize:'10px'
    }
 }))

export default function SignUp() {
    const navigate = useNavigate();
    const {email} = useParams();

    const [data , setData] = useState({name : "" ,email :email ,  password:""});

    //alrt
    const [nameAlrt , setNameAlrt] = useState(false)
    const [emailAlrt , setEmailAlrt] = useState(false)
    const [passwordAlrt , setPasswordAlrt] = useState(false)



    const handle_sumbit = async()=>{
       console.log(data );
        

       //name validation
       if(data.name.length < 4){
        setNameAlrt(true);

        }else{
            setNameAlrt(false);
        }


        //password validation
        let passwordPatten = "^[A-Za-z0-9!@#$%^&*]{8,15}$"
        let RPassword = new RegExp(passwordPatten);


        if(RPassword.test(data.password)){
            setPasswordAlrt(false)
        }else{
            setPasswordAlrt(true);
        }

        
            if( !passwordAlrt && !nameAlrt ){
                if(RPassword.test(data.password) &&  data.name.length >= 4 ){

                    try{
                       let incript_password = Incript_password(data.password);
                        let result = await fetch(`${URL}/user/register` , {
                            method:"POST",
                        body : JSON.stringify({name : data.name ,email :email ,  password:incript_password}),
                        headers : {
                            "content-type" : "application/json"
                        }
                        })
                         SweetAlrt('Sign in ' , "success")
                         navigate('/')
                    }catch(error){
                        SweetAlrt('Sign in ' , "error");
                        console.log('post api error : ' + error)
                    }
                    
                }
            }
        
    }

  return (
    <>
        
    <div className="container" style={{background :'#f2f2f2'}}>
        <div className="wrapper" style={{margin:'0px' , background :  '#FFFF'}}>
            <div className="title"><span>SignUp Form</span></div>
            <form>
            {/* <div className="row">
                <i className="fas fa-user"></i>
                <input type="text"  id='name' placeholder="name " onChange={(e)=>setData({...data , name : e.target.value})}  required/>
            </div>
            {
                    nameAlrt && <AlrtBox>* name length  must  be greter then 3</AlrtBox>
             } */}
             
             <div style={{marginBottom : '1rem'}}>
                {
                    nameAlrt ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Name"
                    onChange={(e)=>setData({...data , name : e.target.value})} 
                    helperText="* name length  must  be greter then 3"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="Name"
                        onChange={(e)=>setData({...data , name : e.target.value})} 
                    />
                }
             </div>



            {/* <div className="row">
                <i className="fas fa-key"></i>
                <input type="password" placeholder="Password" onChange={(e)=>setData({...data , password : e.target.value})} required/>
            </div>
            {
                    passwordAlrt && <AlrtBox>* password  length greter than 8 to 15 </AlrtBox>
            } */}


            <div  style={{marginBottom : '1rem'}}>
                {
                    passwordAlrt ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="password"
                    type='password'
                    onChange={(e)=>setData({...data , password : e.target.value})}
                    helperText="* password  length greter than 8 to 15"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="password"
                        type='password'
                        onChange={(e)=>setData({...data , password : e.target.value})}
                    />
                }
             </div>
            
            <div className="row button">
                <input type="button"  value="Sign UP" onClick={handle_sumbit} />
            </div>
            <div className="signup-link" style={{ color : 'black' }}>Alredy account ? <Link to={'/'}>Login now</Link></div>
            </form>
        </div>
        </div>
    </>
  )
}
